<template>
  <div>
    <h3 class="tab-header">
      {{$t('pages.taskDetails.tabs.comments')}}
    </h3>
    <section
      v-if="comments.length > 0"
      class="content"
    >
      <!-- Comments List -->
      <comment-list
        :avatar="avatar"
        :comments="orderedComments"
        @updateCommentType="updateForEdit"
        :service="service"
      />
    </section>
    <p
      v-else
      class="content-empty"
    >
      {{ $t('pages.taskDetails.comments.noCommentsYet') }}
    </p>
    <blocking-loader :show="allCommentsLoading" />
  </div>
</template>

<script>
import _ from 'lodash'
import Loader from '../../../share/Loader'
import api from '../../../../api'
import CommentList from './List'
import WebStorage from '../../../share/WebStorage'
import BlockingLoader from '../../../share/BlockingLoader'
import CommentMixin from './CommentMixin'

export default {
  components: {
    BlockingLoader,
    CommentList
  },
  mixins: [
    Loader,
    CommentMixin
  ],
  props: {
    editMode: { type: Boolean, default () { return true } },
    service: { type: String, default () { return '' } },
    taskType: { type: String, default () { return 'main' } },
    subtasks: { type: Array, default () { return [] } },
    task: { type: Object, default () { return {} } },
    avatar: { type: String, default () { return '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' } }
  },
  data () {
    return {
      commentsLoaded: [],
      comments: [],
      onCurrentScreen: false
    }
  },
  computed: {
    orderedComments () {
      return _.orderBy(this.comments, ['id'], ['desc'])
    },
    commentTypes () {
      let actions = WebStorage.getSecurityActions()[this.service]
      let actionNamePrefix = '';
      if (this.$isWithClients(this.service)) {
        actionNamePrefix = this.taskType === 'main' ? 'get_comments__main' : 'get_comments__appraisal'
      } else {
        actionNamePrefix = this.taskType === 'main' ? 'get_comments_main' : 'get_comments_appraisal'
      }
      let client = this.$route.meta.client
      return this.getAllowedCommentTypes(actions, actionNamePrefix, client)
    },
    allCommentsLoading () {
      if (this.commentsLoaded.length === 0) {
        return false
      } else if (this.commentTypes.length === this.commentsLoaded.length) {
        if (this.commentsLoaded.every(type => type === true)) {
          return false
        } else if (this.commentsLoaded.some(type => type !== true)) {
          return false
        }
      }
      return true
    }
  },
  mounted () {
    this.$events.on('clickedTab', this.triggerLoad)
    this.$events.on('addComment', this.addComment)
  },
  beforeDestroy () {
    this.$events.off('clickedTab', this.triggerLoad)
    this.$events.off('addComment', this.addComment)
  },
  methods: {
    loadComments () {
      this.commentsLoaded = []
      this.toggleLoading()
      for (let currentType = 0; currentType < this.commentTypes.length; currentType++) {
        const commentType = this.commentTypes[currentType]
        this.commentsLoaded.push(false)
        this.$isWithClients(this.service) ? this.getCommentsClients(commentType, currentType) : this.getCommentsBase(commentType, currentType)
      }
    },
    async getCommentsClients (commentType, currentType) {
      let tasksIds = this.getTasksIdsArray(this.commentTypes[currentType]['action'])
      let dataToSend = {
        tasksIds
      }
      dataToSend[commentType.type] = true
      dataToSend[this.taskType] = true

      if (commentType.client !== null) {
        dataToSend['client'] = commentType.client
      }

      let response = await api.request(this.service, 'post', `comments/search`, dataToSend)
      response.data.forEach((newComment) => {
        if (!this.comments.some(comment => comment.id === newComment.id)) {
          newComment.type = this.mapCommentType(commentType.type)
          this.comments.push(newComment)
        }
      })

      this.commentsLoaded.splice(currentType, 1, true)
    },
    getCommentsBase (commentType, currentType) {
      api.request(this.service, 'get', `tasks/${this.getTasksIds(this.commentTypes[currentType]['action'])}/${this.taskType}/comments/${commentType.type}`)
        .then((response) => {
          response.data.forEach((newComment) => {
            if (!this.comments.some(comment => comment.id === newComment.id)) {
              newComment.type = this.mapCommentType(commentType.type)
              this.comments.push(newComment)
            }
          })
          this.commentsLoaded.splice(currentType, 1, true)
        })
        .catch(() => {
          this.$notify({
            type: 'error',
            title: this.$t('error.default'),
            text: this.$t('pages.taskDetails.comments.errorLoadingComments')
          })
        })
    },
    getIdAsNumber (id) {
      return typeof id !== 'number' ? parseInt(id) : id
    },
    mapCommentType (type) {
      let types = {
        private: 1,
        internal: 2,
        public: 4,
        api: 8,
        inspection_date: 16
      }
      return types[type]
    },
    getTasksIds (commentType) {
      let ids = (this.taskType === 'appraisal') ? [this.$route.params.appraisalTaskId] : [this.$route.params.id]
      ids = ids.concat(this.getSubtasksIds(commentType))
      return ids.join(',')
    },
    getTasksIdsArray (commentType) {
      let ids = (this.taskType === 'appraisal') ? [this.getIdAsNumber(this.$route.params.appraisalTaskId)] : [this.getIdAsNumber(this.$route.params.id)]
      ids = ids.concat(this.getSubtasksIds(commentType))
      return ids
    },
    getSubtasksIds (commentType) {
      let ids = []
      let securityActions = WebStorage.getSecurityActions()[this.service]
      // Check if given main comment type is allowed also for subtask (appraisal)
      if (securityActions.includes(commentType.replace('main', 'appraisal'))) {
        this.subtasks.forEach(subtask => {
          ids.push(subtask.id)
        })
      }
      return ids
    },
    addComment (newComment) {
      // let user = WebStorage.getUser()
      // let comment = {
      //   id: newComment.id,
      //   content: newComment.content,
      //   createdAt: moment().format('YYYY-MM-DD HH:mm:ss'),
      //   uuid: user.uuid,
      //   contractor: user.contractor,
      //   createdBy: user.fullname,
      //   taskSupportedClass: this.taskType,
      //   taskNumber: this.task.number
      // }
      this.loadComments()
      // this.comments.push(comment)
    },
    updateForEdit ({commentId, type}) {
        this.comments.map((comment, index)=>{
            if(comment.id === commentId) {
                comment.type = type
            }
            return comment
        })
    },
    triggerLoad (tabName) {
      if (tabName === 'comments') {
        if (this.onCurrentScreen === false) {
          this.comments = []
          this.loadComments()
          this.onCurrentScreen = true
        }
      } else {
        this.onCurrentScreen = false
        this.comments = []
      }
    }
  }
}
</script>
